import { GET_OFFER_RESPONSE_BY_ID, GET_OFFER_RESPONSES } from "./types";

const initialState = {
  currentOfferResponse: null,
  offerResponses: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OFFER_RESPONSE_BY_ID:
      return {
        ...state,
        currentOfferResponse: action.payload,
      };
    case GET_OFFER_RESPONSES:
      return {
        ...state,
        offerResponses: action.payload,
      };
    default:
      return state;
  }
};
